import { render, staticRenderFns } from "./ProductQueryModal.vue?vue&type=template&id=4dd4aae3"
import script from "./ProductQueryModal.vue?vue&type=script&lang=js"
export * from "./ProductQueryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports